import { render } from "./counterSign.vue?vue&type=template&id=08c5ddcb&scoped=true"
import script from "./counterSign.vue?vue&type=script&lang=js"
export * from "./counterSign.vue?vue&type=script&lang=js"

import "./counterSign.vue?vue&type=style&index=0&id=08c5ddcb&scoped=true&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c5ddcb"]])

export default __exports__